import React from 'react';
import classnames from 'classnames';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

interface ILoaderProps {
  skeleton: boolean;
  isActive: boolean;
  color: string;
  className: string;
  count: number;
  height: number;
  width: number;
}
export default class Loader extends React.Component<ILoaderProps> {
  static defaultProps = {
    skeleton: false,
    isActive: false,
    color: 'white',
    className: '',
    count: 1,
    height: '20px',
    width: undefined,
  };

  render(): React.ReactNode {
    if (this.props.skeleton) {
      return (
        <SkeletonTheme color="#f0f1f3" highlightColor="#e3e5e7">
          <Skeleton style={{ marginBottom: '5px' }} delay={0} width={this.props.width} count={this.props.count} height={this.props.height} />
        </SkeletonTheme>
      );
    }
    return (
      <div
        className={classnames('loading-container', {
          hide: !this.props.isActive,
        }, this.props.color, this.props.className)}
      >
        <div className="loading" />
      </div>
    );
  }
}
